export default __webpack_public_path__ + "static/1-88a5fa113e93490190874ee4c534effb.png";